module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hidden),
      expression: "!hidden"
    }],
    class: _vm.classes,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.select($event)
      },
      "mouseout": function($event) {
        $event.stopPropagation();
        _vm.blur($event)
      }
    }
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.showLabel))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3aca538"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/select/option.vue
// module id = 665
// module chunks = 1